import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FilesInput from '../common/components/formInputs/FilesInput'
import TextInput from '../common/components/formInputs/TextInput'
import SelectInput from '../common/components/formInputs/SelectInput'
import TextareaInput from '../common/components/formInputs/TextareaInput'
import ImageInput from '../common/components/formInputs/ImageInput'
import ClientInput from '../common/components/formInputs/ClientInput'
import { AVAILABLE_FILE_EXTENSIONS, MAX_FILES_NUMBER } from '../common/helpers'

const FirstStep = ({
  displayStep,
  eventTypeOptions,
  trainerOptions,
  formValues,
  setFieldValue,
}) => {
  const { t } = useTranslation(['eventManagement'])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <div className="columns">
        <SelectInput
          columnSize={6}
          name="type"
          label={t('eventManagement:appointmentFormPage.firstStep.typeLabel')}
          placeholder={t('eventManagement:appointmentFormPage.firstStep.typePlaceholder')}
          options={eventTypeOptions}
          value={formValues.type}
          setFieldValue={setFieldValue}
        />
        <ClientInput mainClient={formValues.mainClient} setFieldValue={setFieldValue} />
      </div>
      <div className="columns">
        <SelectInput
          columnSize={6}
          name="organizer"
          label={t('eventManagement:appointmentFormPage.firstStep.trainerLabel')}
          placeholder={t('eventManagement:appointmentFormPage.firstStep.trainerPlaceholder')}
          options={trainerOptions}
          value={formValues.organizer}
          setFieldValue={setFieldValue}
        />
        <TextInput
          columnSize={6}
          name="name"
          label={t('eventManagement:appointmentFormPage.firstStep.nameLabel')}
          placeholder={t('eventManagement:appointmentFormPage.firstStep.namePlaceholder')}
          value={formValues.name}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <TextareaInput
          columnSize={12}
          name="description"
          label={t('eventManagement:appointmentFormPage.firstStep.descriptionLabel')}
          placeholder={t('eventManagement:appointmentFormPage.firstStep.descriptionPlaceholder')}
          value={formValues.description}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <ImageInput
          columnSize={12}
          name="image"
          value={formValues.image}
          eventName={formValues.name}
          eventType="Appointment"
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <FilesInput
          columnsSize={12}
          label={t('eventManagement:appointmentFormPage.firstStep.additionalAssetsLabel')}
          files={formValues.files}
          handleFieldChange={(e) => setFieldValue('files', e.target.value)}
          accept={AVAILABLE_FILE_EXTENSIONS}
          maxNumberOfFiles={MAX_FILES_NUMBER}
          maxFileSizeInMB={3}
        />
      </div>
    </React.Fragment>
  )
}

FirstStep.propTypes = {
  displayStep: PropTypes.bool,
  buildingOptions: PropTypes.array,
  eventTypeOptions: PropTypes.array,
  trainerOptions: PropTypes.array,
  clientOptions: PropTypes.array,
  selectedBuildingId: PropTypes.number,
  formValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default FirstStep
